"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceStatus = exports.RoomStatus = void 0;
var RoomStatus;
(function (RoomStatus) {
    RoomStatus["Healthy"] = "HEALTHY";
    RoomStatus["NotHealthy"] = "NOT_HEALTHY";
})(RoomStatus = exports.RoomStatus || (exports.RoomStatus = {}));
var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["Online"] = "ONLINE";
    DeviceStatus["Offline"] = "OFFLINE";
})(DeviceStatus = exports.DeviceStatus || (exports.DeviceStatus = {}));
